import makeFileUploader from "../../../../helpers/file-upload/file-uploader.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import APP_COMPONENTS from "../components/index.js";
function makeFileSent() {
    return Object.freeze({
        execute
    });
    async function execute(data) {
        const { id, file } = data;
        const isFormValid = APP_COMPONENTS.eventForms.validateForm(id);
        if (!isFormValid) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Incomplete event form. <br>Please fill out all the required fields first before uploading.');
            return;
        }
        const eventForm = APP_COMPONENTS.eventForms.getById(id);
        if (!eventForm)
            return;
        const formRequest = makeFormRequest({ form: eventForm.form, submitBtn: eventForm.submitBtn });
        try {
            APP_COMPONENTS.progressComponents.showProgress(id, file.name);
            APP_COMPONENTS.fileForms.hide(id);
            const uploader = makeFileUploader({ file, path: `event-types/${file.name}`, id });
            const fileURL = await uploader.upload();
            APP_COMPONENTS.fileForms.setURL(id, fileURL);
            APP_COMPONENTS.progressComponents.reset(id);
            APP_COMPONENTS.fileForms.show(id);
            APP_COMPONENTS.eventForms.submit(id);
        }
        catch (e) {
            console.error("CAUGHT UPLOAD ERROR");
            console.error(e);
            formRequest.afterResponse(false);
            APP_COMPONENTS.fileError.show('ERROR', 'An error occurred while uploading the file. <br><br>Please check your internet connection');
            APP_COMPONENTS.fileForms.show(id);
            APP_COMPONENTS.progressComponents.reset(id);
        }
    }
}
const fileSent = makeFileSent();
export default fileSent;
